import { Uuid } from "@/domains/global/identifiers";
import { SmartViewKind } from "@/domains/smart/constants";
import { v5 as uuidv5 } from "uuid";
import { UuidNamespace } from "@/modules/uuid/constants";

export interface SmartContextDescriptor {
  spaceAccountId: Uuid | null;
  activeNoteId?: Uuid | null;
  query?: string | null;
  smartViewKind?: SmartViewKind | null;
}

export function resolveSmartContextId({
  spaceAccountId,
  activeNoteId = null,
  query = null,
  smartViewKind = SmartViewKind.HeadsUp,
}: SmartContextDescriptor): string | null {
  if (!spaceAccountId) return null;

  const spaceAccountIdString = String(spaceAccountId).toUpperCase();
  const activeNoteIdString = activeNoteId ? String(activeNoteId).toUpperCase() : null;

  const idSegments: string[] = [];

  if (activeNoteIdString) {
    idSegments.push(`ACTIVE_NOTE::${activeNoteIdString}`);
  } else if (query) {
    idSegments.push(`QUERY::${query}`);
  } else {
    idSegments.push("NONE");
  }

  if (activeNoteIdString && query) {
    idSegments.push(`QUERY::${query}`);
  }

  if (smartViewKind) {
    idSegments.push(`VIEW_KIND::${smartViewKind}`);
  }

  const upperSegments = idSegments.map(segment => segment.toUpperCase());
  const namespaceName = upperSegments.join("::");

  const derivedNamespace = uuidv5(namespaceName, UuidNamespace.SmartContextNamespace);

  return uuidv5(spaceAccountIdString, derivedNamespace);
}
